{
  "title": "Weekly Digest",
  "rounds": {
    "singular": "round",
    "plural": "rounds"
  },
  "questions": "questions",
  "accuracy": "accuracy"
}
